





















































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import ImageUpload from '@/components/ImgUpload/index.vue'
import { addAssembly, queryAssemblyById, updateAssembly } from '@/api/assembly.ts'
import { getToken } from '@/utils/cookies'
import { encrypt, decrypt } from '@/utils/crypto'

interface ImageItem {
  imgUrl: string;
  title: string;
  hrefUrl: number;
  id?: string;
}

@Component({
  name: 'addEventIntroduction',
  components: {
    HeadLable,
    ImageUpload
  }
})
export default class extends Vue {
  private restKey: number = 0
  private title = '新建赛事介绍';
  private titleTitle = '';
  private actionType: string = 'add'
  private readonly right = 'right';
  private vueRest = '1'
  private titleId = ''
  private titleId1 = ''
  private headers = {
    token: getToken()
  }

  private ruleForm = {
    id: '',
    images: [] as ImageItem[],
    type: 1
  }

  get rules() {
    return {
      images: {
        validator: (rule: any, value: ImageItem[], callback: any) => {
          if (!value || value.length === 0) {
            callback(new Error('请至少上传一张图片'));
          } else {
            callback();
          }
        }
      }
    }
  }

  created() {
    this.titleId1 = this.$route.query.titleId;
    this.titleTitle = this.$route.query.title;
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改赛事介绍信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  private async init() {
    queryAssemblyById(this.$route.query.id as string).then(res => {
      if (res && res.data && res.data.code === 1) {
        const data = res.data.data;
        this.ruleForm.id = data.id;

        // Convert single image to array format for compatibility
        if (data.imgUrl) {
          this.ruleForm.images = [{
            imgUrl: data.imgUrl,
            title: data.title || '',
            hrefUrl: parseInt(data.hrefUrl) || 1,
            id: data.id
          }];
        }
      } else {
        this.$message.error(res.data.msg)
      }
    })
  }

  cancel() {
    this.$router.push({ path: '/competition/eventIntroductionManage', query: { titleId: this.titleId1, title: this.titleTitle } })
  }

  private handleImageUpload(imageUrl: string) {
    // For multiple uploads, you might need to modify your ImageUpload component
    // to emit an array of URLs or emit multiple events
    // This is a temporary implementation - you'll need to adjust based on your actual upload component
    this.ruleForm.images.push({
      imgUrl: imageUrl,
      title: '',
      hrefUrl: this.ruleForm.images.length + 1
    });
  }

  private moveUp(index: number) {
    if (index > 0) {
      const temp = this.ruleForm.images[index];
      this.$set(this.ruleForm.images, index, this.ruleForm.images[index - 1]);
      this.$set(this.ruleForm.images, index - 1, temp);
    }
  }

  private moveDown(index: number) {
    if (index < this.ruleForm.images.length - 1) {
      const temp = this.ruleForm.images[index];
      this.$set(this.ruleForm.images, index, this.ruleForm.images[index + 1]);
      this.$set(this.ruleForm.images, index + 1, temp);
    }
  }

  private removeImage(index: number) {
    this.ruleForm.images.splice(index, 1);
    if (this.ruleForm.images.length === 0) {
      (this.$refs.ruleForm as any).validate();
    }
  }

  private submitForm(formName: any) {
    (this.$refs[formName] as any).validate((valid: boolean) => {
      if (valid) {
        const params: any = {
          titleId: this.titleId,
          type: 1,
          images: this.ruleForm.images.map(img => ({
            imgUrl: img.imgUrl,
            title: img.title,
            hrefUrl: img.hrefUrl,
            id: img.id
          }))
        };

        if (this.actionType === 'add') {
          addAssembly(params)
            .then(res => {
              if (res.data.code === 1) {
                this.$message.success('赛事介绍添加成功！');
                this.$router.push({ path: '/competition/eventIntroductionManage', query: { titleId: this.titleId1, title: this.titleTitle } });
              } else {
                this.$message.error(res.data.desc || res.data.msg);
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message);
            });
        } else {
          params.id = this.ruleForm.id;
          updateAssembly(params)
            .then(res => {
              if (res && res.data && res.data.code === 1) {
                this.$message.success('赛事介绍修改成功！');
                this.$router.push({ path: '/competition/eventIntroductionManage', query: { titleId: this.titleId1, title: this.titleTitle } });
              } else {
                this.$message.error(res.data.desc || res.data.msg);
              }
            })
            .catch(err => {
              this.$message.error('请求出错了：' + err.message);
            });
        }
      }
    });
  }
}
